import request from "@/utils/request";

// 查询竞赛量表列表
export const  listScale =(data) =>{
    return request({
        url: "/businessservice/eduScale/list",
        method:"post",
        data: data
    })
}

// 创建竞赛量表
export const  createScale =(data) =>{
    return request({
        url: "/businessservice/eduScale/create",
        method:"post",
        data: data
    })
}


// 查询竞赛量表详情
export const  infoScale =(query) =>{
    return request({
        url: "/businessservice/eduScale/info",
        method:"get",
        params: query
    })
}

// 删除
export const  deleteScale =(query) =>{
    return request({
        url: "/businessservice/eduScale/delete",
        method:"get",
        params: query
    })
}